import { forwardRef } from 'react'
import { Container } from '@leroy-merlin-br/backyard-react'

import * as S from './styled'
import { WrapperWeb } from './components/WrapperWeb'

interface BreadcrumbBarProps {
  isSearchResultPage: boolean
  apiDomain: string
  categoryId: string
}

const BreadcrumbBar = forwardRef(
  ({ isSearchResultPage, apiDomain, categoryId }: BreadcrumbBarProps, ref) => {
    const wrapperWebProps = {
      apiDomain,
      isSearchResultPage,
      categoryId
    }

    return (
      <S.BreadcrumbBar ref={ref}>
        <Container>
          <WrapperWeb {...wrapperWebProps} />
        </Container>
      </S.BreadcrumbBar>
    )
  }
)

export default BreadcrumbBar
